import { render } from "./calendar-plus.vue?vue&type=template&id=44f4a79a&ts=true"
import script from "./calendar-plus.vue?vue&type=script&lang=ts"
export * from "./calendar-plus.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__